import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React from 'react';
import clientConfig from 'universal-config';
import { readLocalStorage } from 'redux/saga/helpers/local-storage';
var spScriptRendered = false;
var SNOWPLOW_ENABLED = __CLIENT__ || __TEST__;
var SP_INIT_JS = "(function(p,l,o,w,i,n,g){if(!p[i]||!p[i].track){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];\n  p.GlobalSnowplowNamespace.push(i);if(!p[i]){p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)}};\n  p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;n.src=w;\n  g.parentNode.insertBefore(n,g)}}(window,document,\"script\",\"//d1fc8wv8zag5ca.cloudfront.net/2.6.1/sp.js\",\"snowplow\"));";
var TRACKER = clientConfig().snowplow.tracker;
export var trackUnstruct = function trackUnstruct(name) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (SNOWPLOW_ENABLED) {
    if (__CLIENT__ && readLocalStorage('trackingDebug')) {
      console.info('Tracking snowplow', name, data); // eslint-disable-line no-console
    }

    if (!window.snowplow) {
      window.snowplow = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (window.snowplow.q = window.snowplow.q || []).push(args);
      };
    }

    window.snowplow("trackUnstructEvent:".concat(TRACKER), {
      schema: 'iglu:com.classpass/general_event/jsonschema/1-0-0',
      data: {
        event_type: name,
        event_data: JSON.stringify(data || {})
      }
    });
  }
};
export var SnowplowTracker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SnowplowTracker, _React$Component);

  function SnowplowTracker() {
    _classCallCheck(this, SnowplowTracker);

    return _possibleConstructorReturn(this, _getPrototypeOf(SnowplowTracker).apply(this, arguments));
  }

  _createClass(SnowplowTracker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          host = _this$props.host,
          appId = _this$props.appId;

      if (spScriptRendered && !__TEST__) {
        return;
      }

      spScriptRendered = true;
      var sdkInitJs = "snowplow('newTracker', '".concat(TRACKER, "', '").concat(host, "', {\n      appId: '").concat(appId, "',\n      platform: 'web',\n      bufferSize: 1,\n      encodeBase64: true,\n      forceSecureTracker: true,\n      post: false\n    });");
      var script = document.createElement('script');
      script.textContent = SP_INIT_JS + sdkInitJs;
      script.id = 'sp-js-root';
      document.body.appendChild(script);
    }
  }, {
    key: "render",
    value: function render() {
      return false;
    }
  }]);

  return SnowplowTracker;
}(React.Component);
SnowplowTracker.propTypes = {
  host: PropTypes.string.isRequired,
  appId: PropTypes.string.isRequired
};